import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./RootReducer";

export const store = configureStore({
  reducer: rootReducer,
  // TODO: add a devtools value below
  // devTools: dev env'
});
